import Slider from "@/components/Slider"
import Link from "next/link"
import React from "react"
import Icons from "../Icon"
import style from "./style.scss"

interface TutorialSliderProps {
  slides: any
}

const TutorialSlider: React.SFC<Readonly<TutorialSliderProps>> = (props) => {
  return (
    <div className={style.tutorialSlider}>
      <Link href="/missions">
        <a className={style.close}>
          <Icons.Cross />
        </a>
      </Link>
      {props.slides && (
        <Slider
          title="Tutorial slides"
          slides={props.slides}
          speed={5000}
          autoplay={true}
          dots={false}
          style={style}
        />
      )}
    </div>
  )
}

export default TutorialSlider
